module.exports = __webpack_public_path__ + "img/onboarding_icon_5.e43cb0e6.svg";